<template>
  <div class="col-md-6">
    <div>
      <ul class="bold name">
        <li> {{proxy.recipient_name}} </li>
      </ul>
      <!-- <p><a href="#"><i class="pg-arrow_lright_line_alt"></i>Télécharger le document</a></p> -->
    </div>
    <div v-if="!contract.terminated" class="button">
      <button class="btn btn-sm" @click="$emit('remove')">Supprimer</button>
    </div>
    <hr>
  </div>
</template>

<style lang="scss" scoped>
  div {
    position: relative;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      line-height: 1.2rem;
    }
  }

  .name {
    font-size: 0.9rem;
  }

  .button {
    position: absolute;
    right: 0;
    bottom: 40px;
  }
</style>


<script type="text/babel">
  export default {
    props: ["proxy", 'contract']
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/PersonnalPostalProxy/Item.vue